export default __webpack_public_path__ + "static/media/stickermule.1beb6466.png";